import React, { Fragment, useState } from "react";
import Parser from "application/components/parser";
import getErrorCss from "module/functions/getErrrorCss";
import isEmpty from "ramda/src/isEmpty";
import { translate } from "application/functions";
import ErrorInput from "assets/img/error-input";
const TextInput = (props) => {
  const { name, path, register, errors, defaultValue, users, isNumber, setOnFocus, className } = props;
  const [value, setValue] = useState("");

  let anotherError = null;

  switch (name) {
    case "<p>Email</p>":
      if (errors?.messages !== "undefined" && errors?.messages?.includes(translate("field.email"))) {
        anotherError = translate("field.email");
      }
      break;
    case "<p>Mobile</p>":
      if (errors?.messages !== "undefined" && errors?.messages?.includes(translate("field.mobile"))) {
        anotherError = translate("field.mobile");
      }
      break;

    default:
      break;
  }
  const [focus, setFocus] = useState(false);
  const typeInput = isNumber ? "number" : "text";
  const handleFocus = (boolean) => {
    setFocus(boolean);
    setOnFocus(boolean);
  };

  const cleanMobile = (value) => {
    const firstChar = value[0] === "+" ? "+" : "";
    const newValue = value.replace(/\D/g, "");
    return firstChar + newValue;
  };

  const handleInput = (e, type) => {
    const value = e.target.value;
    value ? e.target.classList.add("focus") : e.target.classList.remove("focus");
    if (type === "number") {
      const regex = /^[+]?\d+$/;
      if (value === "" || regex.test(value)) {
        setValue(value);
      } else {
        setValue(cleanMobile(value));
        e.target.value = cleanMobile(value);
      }
    } else {
      setValue(value);
    }
  };

  const setMaxLength = (path) => {
    switch (true) {
      case path.includes("floor"):
        return 50;
      case path.includes("message"):
        return 250;
      case path.includes("address"):
        return 150;
      case path.includes("material"):
        return 60;
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <div
        className={`${`field-creator__field-container${getErrorCss(path, errors)}`} ${
          users && "field-creator__field-container-users"
        }`}
      >
        <Parser
          className={`field-creator__labelfield ${(focus || value) && "focus"}`}
          text={name}
          hasValue={!isEmpty(value)}
        />
        <input
          className={`field-creator__textfield ${className ?? ""}`}
          type="text"
          name={path}
          maxLength={setMaxLength(path)}
          ref={register}
          defaultValue={defaultValue}
          onInput={(e) => handleInput(e, typeInput)}
          onFocus={() => {
            handleFocus(true);
          }}
          onBlur={() => {
            handleFocus(false);
          }}
        />

        <div className="errorsShowed">
          <ErrorInput />
          <span>{anotherError || translate("field.required")}</span>
        </div>
      </div>
    </Fragment>
  );
};

export default TextInput;
